module.exports = __webpack_public_path__ + "static/media/mola-architecture.bc3180c3.png";